import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export default function ChangePasswordStep({
  currentPwd, setCurrentPwd, newPwd, setNewPwd, confirmPwd, setConfirmPwd,
  onSubmit, onCancel, processing,
}) {
  return (
    <div className="space-y-4 mt-4">
      <p className="text-sm text-muted-foreground">Enter your current password and choose a new one.</p>
      <div>
        <Label>Current password</Label>
        <Input data-testid="current-password-input" type="password" value={currentPwd} onChange={(e) => setCurrentPwd(e.target.value)} className="mt-2" />
      </div>
      <div>
        <Label>New password</Label>
        <Input data-testid="new-password-input" type="password" minLength={6} value={newPwd} onChange={(e) => setNewPwd(e.target.value)} className="mt-2" />
      </div>
      <div>
        <Label>Confirm new password</Label>
        <Input data-testid="confirm-password-input" type="password" value={confirmPwd} onChange={(e) => setConfirmPwd(e.target.value)} className="mt-2" />
      </div>
      <div className="flex gap-3">
        <Button data-testid="change-password-confirm-btn" onClick={onSubmit} disabled={processing || !currentPwd || !newPwd} className="flex-1 rounded-full bg-primary hover:bg-primary/90">
          Update Password
        </Button>
        <Button onClick={onCancel} variant="outline" className="flex-1 rounded-full">Cancel</Button>
      </div>
    </div>
  );
}
